module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_galgenen-9b23eb149aa7613a2f16c34c194e8e43.png";